import { jsx as _jsx } from "react/jsx-runtime";
import { DebugPopover } from "./DebugPopover";
export function DebugItemPopover(props) {
    return (_jsx(DebugPopover, { src: props.item, color: props.color, type: props.type, title: props.title, chipSx: props.chipSx }));
}
//# sourceMappingURL=DebugItemPopover.js.map